import { RootState } from "@/store/store";
import { normalizedCostWidgetByWidgetIdEndpointSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetByWidgetIdEndpointSelector";

export const normalizedCostWidgetByWidgetIdLoadingSelector = (
  state: RootState,
  widgetId: string,
) => {
  const response = normalizedCostWidgetByWidgetIdEndpointSelector({
    widgetId,
  })(state);

  return !!response?.isLoading;
};
